export enum SELECT_TIME_SLOTS_TRANSITIONS {
  FETCH_SLOTS = 'FETCH_SLOTS',
  SELECT_DAY = 'SELECT_DAY',
  SELECT_HOUR = 'SELECT_HOUR',
  SET_DELIVERY_INFOS = 'SET_DELIVERY_INFOS',
  CLEAR_SELECTION = 'CLEAR_SELECTION',
}
